"use client";

import React from "react";
import { ShieldAlert, ArrowRight } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ArenasNotice() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="inflatablesafetyarenasnotice" data-nav="light" className="bg-background text-foreground py-12 md:py-16 px-4 sm:px-6 lg:px-8 border-b border-border">
      <div className="max-w-5xl mx-auto">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: "-40px"
      }} transition={{
        duration: 0.45,
        ease: "easeOut"
      }} className="bg-card text-card-foreground border border-border p-6 sm:p-8 md:p-10 shadow-sm relative overflow-hidden">
          {/* Subtle industrial corner badge marker */}
          <div className="absolute top-0 right-0 border-l border-b border-border bg-muted px-3 py-1 text-[11px] font-mono uppercase tracking-wider text-muted-foreground">
            Equipment Note
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
            {/* Header and indicator column */}
            <div className="lg:col-span-5 space-y-3">
              <div className="inline-flex items-center gap-2 text-primary font-mono text-xs uppercase tracking-widest">
                <ShieldAlert className="size-4 shrink-0 text-primary" aria-hidden="true" />
                <span>Safety & Containment</span>
              </div>
              <h2 className="text-2xl sm:text-3xl font-serif font-bold tracking-tight uppercase text-foreground leading-tight">
                Mechanical Bulls With Inflatable Safety Arenas
              </h2>
            </div>

            {/* Content and action column */}
            <div className="lg:col-span-7 space-y-4 text-muted-foreground font-default text-sm sm:text-base leading-relaxed">
              <p>
                Many complete mechanical bull systems use an inflatable safety arena around the powered ride. However, the bull and inflatable should be compared as separate parts of the package because condition, dimensions, blower requirements and replacement needs can differ.
              </p>
              <p>
                If you specifically want a mechanical bull with an inflatable arena, our dedicated guide explains what should come with the system and what to check before you buy.
              </p>

              <div className="pt-2">
                <Button asChild variant="default" className="font-serif uppercase tracking-wider font-semibold text-xs sm:text-sm px-6 py-5 bg-primary text-primary-foreground hover:bg-primary/90 transition-colors">
                  <Link to="/InflatableMechanicalBullsPage" className="inline-flex items-center gap-2">
                    <span>VIEW INFLATABLE MECHANICAL BULLS</span>
                    <ArrowRight className="size-4 shrink-0" aria-hidden="true" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}